import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokePostService } from '../../../store/global/actions'

const DeleteProfile = (props) => {

    const { id, onClose, onCompletion } = props

    const [loading, setLoading] = useState(false);


    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService('deleteProfile', {}, [id])).then(res => {
            if (res?.status === true) {
                onCompletion('Profile', 'delete')
            } else {
                const errors = res?.data?.validationErrors ? res?.data?.validationErrors : [];
                if (errors.length > 0) {
                }
                if (res?.code === 255) {
                    onClose();
                }
            }
            setLoading(false);
        });


    }

    const dispatch = useDispatch();

    return (
        <Grid container direction={"row"} spacing={1} >
            <Grid item xs={12}>
                <Typography variant="h6">Delete</Typography>
            </Grid>
            <Grid item xs={12} >
                <Divider />
            </Grid>

            <Grid item xs={12}>
                <Typography> Are you sure you want to delete the profile? </Typography>
            </Grid>
            <Grid item xs={12} >
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", textTransform: 'capitalize' }} >
                <DeleteCancel onCancel={onClose} onDelete={onDelete} disableButton={loading} content={loading ? 'Deleting..' :  'Delete'} />
            </Grid>

        </Grid>
    )
}


export default DeleteProfile;